import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["content", "children", "className", "placement", "showArrow"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import cx from 'classnames';
import './styles.sass';
import { usePopperTooltip } from 'react-popper-tooltip';
export var Tooltip = function Tooltip(_ref) {
  var content = _ref.content,
    children = _ref.children,
    className = _ref.className,
    placement = _ref.placement,
    _ref$showArrow = _ref.showArrow,
    showArrow = _ref$showArrow === void 0 ? true : _ref$showArrow,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _usePopperTooltip = usePopperTooltip(_objectSpread({
      placement: placement
    }, rest)),
    getTooltipProps = _usePopperTooltip.getTooltipProps,
    getArrowProps = _usePopperTooltip.getArrowProps,
    setTooltipRef = _usePopperTooltip.setTooltipRef,
    setTriggerRef = _usePopperTooltip.setTriggerRef,
    visible = _usePopperTooltip.visible;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    ref: setTriggerRef
  }, children), visible && /*#__PURE__*/React.createElement("div", _extends({
    ref: setTooltipRef
  }, getTooltipProps({
    className: cx('tooltipContainer', className)
  })), showArrow && /*#__PURE__*/React.createElement("div", getArrowProps({
    className: cx('tooltipArrow'),
    'data-placement': placement
  })), content));
};
//# sourceMappingURL=index.js.map
